import { registerController } from "../main";

registerController("event-form", (el: HTMLElement) => {
  const allDayCheckbox = el.querySelector<HTMLInputElement>("[data-event-all-day]");
  const startInput = el.querySelector<HTMLInputElement>("[data-event-start]");
  const endInput = el.querySelector<HTMLInputElement>("[data-event-end]");

  if (!allDayCheckbox || !startInput || !endInput) return;

  function applyMode(): void {
    if (!allDayCheckbox || !startInput || !endInput) return;

    if (allDayCheckbox.checked) {
      // Switch to date-only inputs
      const startVal = startInput.value;
      const endVal = endInput.value;
      startInput.type = "date";
      endInput.type = "date";
      // Strip time portion if present (datetime-local format: "2026-03-22T14:30")
      if (startVal.includes("T")) {
        startInput.value = startVal.split("T")[0];
      }
      if (endVal.includes("T")) {
        endInput.value = endVal.split("T")[0];
      }
    } else {
      // Switch back to datetime-local inputs
      const startVal = startInput.value;
      const endVal = endInput.value;
      startInput.type = "datetime-local";
      endInput.type = "datetime-local";
      // Append default time if value is date-only
      if (startVal && !startVal.includes("T")) {
        startInput.value = startVal + "T09:00";
      }
      if (endVal && !endVal.includes("T")) {
        endInput.value = endVal + "T10:00";
      }
    }
  }

  // Apply initial state
  applyMode();

  // Listen for changes
  allDayCheckbox.addEventListener("change", applyMode);
});
